import { ITenant } from './tenant.model';
import { IDomain } from './domain.model';

export interface IUser {
  id?: any;
  tenant?: ITenant;
  domain?: IDomain;
  firstName?: string;
  lastName?: string;
  email?: string;
  activated?: boolean;
  langKey?: string;
  authorities?: any[];
  createdBy?: string;
  createdDate?: Date;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
  password?: string;
  mobile?: string;
}

export const defaultValue: Readonly<IUser> = {
  id: '',
  tenant: null,
  domain: null,
  firstName: '',
  lastName: '',
  email: '',
  activated: false,
  langKey: 'en',
  authorities: [],
  createdBy: '',
  createdDate: null,
  lastModifiedBy: '',
  lastModifiedDate: null,
  password: '',
  mobile: ''
};
